/* eslint-disable */
const { env } = require('../config/env');
if (env === 'production') {
  __webpack_public_path__ = window.__app.context.cdn && window.__app.context.cdn + '/v/dist/';
}
export default __webpack_public_path__;
